import { render, staticRenderFns } from "./ModuleNotFound.vue?vue&type=template&id=01b36fe3&"
import script from "./ModuleNotFound.vue?vue&type=script&lang=js&"
export * from "./ModuleNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports